import { render, staticRenderFns } from "./PrivacyProtocolKYY.vue?vue&type=template&id=2d715455&scoped=true"
import script from "./PrivacyProtocolKYY.vue?vue&type=script&lang=js"
export * from "./PrivacyProtocolKYY.vue?vue&type=script&lang=js"
import style0 from "./PrivacyProtocolKYY.vue?vue&type=style&index=0&id=2d715455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d715455",
  null
  
)

export default component.exports